import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingBag, FaUser, FaSearch, FaBars, FaTimes } from 'react-icons/fa';
import { CartContext } from '../../context/CartContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { getTotalItems } = useContext(CartContext);

  const navLinks = [
    { name: 'Gold Collection', path: '/shop?category=gold' },
    { name: 'Silver Collection', path: '/shop?category=silver' },
    { name: 'Necklaces', path: '/shop?category=necklace' },
    { name: 'Rings & Earrings', path: '/shop?category=rings' },
  ];

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
          <Link to="/" className="logo">
            <div className="logo-icon">
              <img 
                src="/logo192.png" 
                alt="श्रीPATI Gold & Silver" 
                className="logo-img"
              />
            </div>
            <div className="logo-text">
              <span className="devnagari">श्री</span>
              <span className="pati-text">PATI</span>
            </div>
          </Link>
        </div>

        <nav className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} onClick={() => setIsMenuOpen(false)}>
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="header-right">
          <FaSearch className="icon" />
          <FaUser className="icon" />
          <Link to="/cart" className="cart-icon">
            <FaShoppingBag className="icon" />
            <span className="cart-badge">{getTotalItems()}</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;